import { history, toastConfig, url } from './variables';
import { toast as toastify } from 'react-toastify';
import configureStore from '../redux/store';
import Axios from 'axios';
import i18n from "i18next";

//toast
export function toast(message, type = 'success' ,autoClose = 5000) {
    toastify.dismiss()
    toastify[type](message, {...toastConfig,autoClose})
}

//validation
export function validate(form) {
    const data = [...form.current.children].map(child => JSON.parse(child.getAttribute('data-props')));
    return data.reduce((err, data) => {
        if (data && data.required && !data.value && data.value !== 0) return `${err}${err ? '،' : ''} ${data.label}`;
        return err;
    }, '');
}

//price
export function numToPrice(num = 0) {
    return num.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',') +`${ num < 0  ? '-': ''}`;
}

export function priceSum(array = []) {
    const data = typeof array === 'string' ? JSON.parse(array) : array;
    let result = 0;
    data.forEach(itm => {
        if (itm.price)
            result += Number(itm.price.replace(/[^0-9]+/g, ''));
    });
    return result;
}

// axios
export function pexios(apiURL, method = 'get', data = {}, file = false) {
    const { store } = configureStore();
    const token = store.getState().token;
    const Authorization = token ? `Bearer ${token}` : '';
    const options = {
        baseURL: url,
        url: apiURL,
        method,
        data,
        headers: {
            contentType: file ? 'multipart/form-data' : 'application/json',
            Authorization,
        },
    };
    return Axios(options)
        .catch(err => {
            // if (err?.response?.status === 401) {
            //     history.push('/login');
            //     toast('لطفا دوباره وارد شوید.', 'error');
            // }
            if (err?.response?.status === 401 || err?.response?.status === 520) {
                history.push({
                    pathname: '/error',
                    state: err,
                })
            }
            
            return Promise.reject(err);
        });
}


//upload images
export function uploadImages({ id, type, name, image, done, callback }) {
    const fd = new FormData();
    fd.append('id', id);
    fd.append('type', type);
    fd.append(name, image);
    pexios('api/upload_image', 'post', fd, true)
        .then(res => {
            callback(res.data);
            done();
        })
        .catch(() => {
            if(i18n.language === 'en') {
                toast('Problem loading', 'error');
                done();
            }else if(i18n.language === 'ru') {
                toast('Проблема с загрузкой', 'error');
                done();
            }else if(i18n.language === 'ar') {
                toast('مشكلة في التحميل', 'error');
                done();
            }else if(i18n.language === 'tu') {
                toast('Yükleme sorunu', 'error');
                done();
            }else{
                toast('مشکل در بارگزاری', 'error');
                done();
            }
        });
}

//hardCopy
export function hardCopy(data) {
    return JSON.parse(JSON.stringify(data));
}

//get query string from url
export function getQueryString(param) {
    let queryString = window.location.search.substr(1);
    queryString = queryString.split('&');
    let value = undefined;
    queryString.forEach(itm => {
        const array = itm.split('=');
        if (array[0] === param) value = array[1];
    });
    return value;
}

//remove query string array from url
export function  removeQueryParam(param) {
    let queryString = window.location.search.substr(1);
    queryString = queryString.split('&');
    const queryStringObject = {};
    queryString.forEach(itm => {
        const array = itm.split('=');
        queryStringObject[array[0]] = array[1];
    });
    delete queryStringObject[param];
    const newQsArray = Object.keys(queryStringObject).map(itm => (
        `${itm}=${queryStringObject[itm]}`
    ));
    history.push(`${window.location.pathname}?${newQsArray.join('&')}`);
}
//css direction
export function getDirection(lang){
    if(['en','ru'].includes(lang)) {
        return 'leftToRight'
    }else{
        return 'rightToLeft'
    }
}